
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDButton from "components/MDButton";
import ButtonGroup from "@mui/material/ButtonGroup";
import CustomAlert from "components/CustomAlert";
import MDInput from "components/MDInput";
import CircularProgress from '@mui/material/CircularProgress';
import ProductLineSkeleton from "components/ProductLineSkeleton";

// Data
import { useEffect, useState } from "react";
import { ProductLineAPI } from "api/ProductLineAPI";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { useMaterialUIController, setLoading } from "context";
import { useParams } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup'


export default function CreateEditProductLine() {
  const [controller, dispatch] = useMaterialUIController();
  const [alert, setAlert] = useState(false);
  const [alertContent, setAlertContent] = useState('');
  const [alertColor, setAlertColor] = useState('info');
  const navigate = useNavigate();
  const { loading } = controller;

  const { id } = useParams();
  const isCreateMode = !id;

  const formSchema = yup.object().shape({
    linea: yup.string().required('El campo es requerido').max(30, 'El código no debe tener más de 30 caracteres'),
    nombre_linea: yup.string().required('El campo es requerido').max(30, 'El código no debe tener más de 30 caracteres'),
  })

  const { handleSubmit, control, formState: { errors, isSubmitting }, setValue } = useForm({ resolver: yupResolver(formSchema), });

  const handleAlert = (content, color) => {
    setAlertContent(content);
    setAlertColor(color);
    setAlert(true)
  }

  const handleAlertClose = () => {
    setAlert(false);
  }

  const onSubmit = (data) => {
    return isCreateMode
      ? createProductLine(data)
      : updateProductLine(id, data);
  }

  const createProductLine = (data) => {
    return ProductLineAPI.store(data)
      .then(response => {
        navigate('/product-lines', { state: response.message });

      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
          window.scrollTo(0, 0);
        }
      });
  }

  const updateProductLine = (id, data) => {
    return ProductLineAPI.update(id, data)
      .then(response => {
        navigate('/product-lines', { state: response.message });

      }).catch(error => {
        if (error.response) {
          handleAlert(error.response.data.message, 'error')
          window.scrollTo(0, 0);
        }
      });
  }

  const getProductLine = (id, signal) => {
    return ProductLineAPI.show(id, signal).then(response => {
      for (let [key, value] of Object.entries(response.productLine)) {
        setValue(key, value)
      }
    }).catch(error => {
      navigate('/not-found');
    }).finally(() => {
      setLoading(dispatch, false)
    });
  }

  useEffect(() => {
    const abortController = new AbortController();
    const signal = abortController.signal

    if (!isCreateMode) {
      setLoading(dispatch, true)
      getProductLine(id, signal);
    }

    return () => {
      abortController.abort();
    };

  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container justifyContent="center" pb={3} >
        <MDBox sx={{
          width: '80%',
        }}>
          <MDBox mb={4} px={2} >
            <CustomAlert severity={alertColor} message={alertContent} open={alert} onClose={handleAlertClose}></CustomAlert>
          </MDBox>
          <Card>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12}>
                <MDBox p={2} lineHeight={0}>
                  <MDTypography variant="h5">Lineas de Producto</MDTypography>
                  <MDTypography variant="button" color="text" fontWeight="regular">
                    Información de la Linea de Producto
                  </MDTypography>
                </MDBox>
                {loading ? <ProductLineSkeleton></ProductLineSkeleton> : (
                  <MDBox p={2} component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                    <Grid container p={2} spacing={3}>
                      <Grid item xs={6} sm={6}>
                        <Controller
                          control={control}
                          name="linea"
                          render={({ field: { onChange, value } }) => (
                            <MDInput onChange={onChange} value={value || ''} label="Linea" variant="standard" fullWidth />
                          )}
                        />
                        {errors.linea && <MDTypography variant="button" color="error">{errors.linea?.message}</MDTypography>}
                      </Grid>
                      <Grid item xs={6} sm={6}>
                        <Controller
                          control={control}
                          name="nombre_linea"
                          render={({ field: { onChange, value } }) => (
                            <MDInput onChange={onChange} value={value || ''} label="Nombre Linea" variant="standard" fullWidth />
                          )}
                        />
                        {errors.nombre_linea && <MDTypography variant="button" color="error">{errors.nombre_linea?.message}</MDTypography>}
                      </Grid>
                    </Grid>
                    <MDBox sx={{ display: 'flex', justifyContent: 'flex-end' }} p={5}>
                      <ButtonGroup>
                        <MDButton variant="gradient" color="secondary" onClick={() => navigate('/product-lines')} >
                          Cancelar
                        </MDButton>
                        <MDButton variant="gradient" type="submit" color="info" disabled={isSubmitting}>
                          {isSubmitting ? <CircularProgress size={18} color="white" /> : 'Guardar'}
                        </MDButton>
                      </ButtonGroup>
                    </MDBox>
                  </MDBox>
                )}
              </Grid>
            </Grid>
          </Card>
        </MDBox>
      </Grid >
      <Footer />
    </DashboardLayout >
  );

}



